interface SenseiMarkProps {
  size?: number;
}

export function SenseiMark({ size = 40 }: SenseiMarkProps) {
  return (
    <svg
      className="mark-svg"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
    >
      <g className="outer">
        <path fill="#5B6CFF" d="M 24.189 13.138 A 45 45 0 0 1 75.811 13.138 L 67.781 24.606 A 31 31 0 0 0 32.219 24.606 Z"/>
        <path fill="#5B6CFF" d="M 94.829 46.078 A 45 45 0 0 1 69.018 90.784 L 63.101 78.096 A 31 31 0 0 0 80.882 47.298 Z"/>
        <path fill="#5B6CFF" d="M 30.982 90.784 A 45 45 0 0 1 5.171 46.078 L 19.118 47.298 A 31 31 0 0 0 36.899 78.096 Z"/>
      </g>
      <g className="inner">
        <path fill="#EC4899" d="M 58.893 25.568 A 26 26 0 0 1 75.605 54.515 L 63.787 52.431 A 14 14 0 0 0 54.788 36.844 Z"/>
        <path fill="#EC4899" d="M 66.712 69.917 A 26 26 0 0 1 33.288 69.917 L 41.001 60.725 A 14 14 0 0 0 58.999 60.725 Z"/>
        <path fill="#EC4899" d="M 24.395 54.515 A 26 26 0 0 1 41.107 25.568 L 45.212 36.844 A 14 14 0 0 0 36.213 52.431 Z"/>
      </g>
    </svg>
  );
}
